import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { RosterCell, OverrideRequest, BulkSwapRequest } from '../interfaces/shift/RosterCell';

export const ShiftRosterService = {
    getRoster: async (institutionId: string, from: string, to: string,
                      userId?: string, shiftId?: string): Promise<RosterCell[]> => {
        const params: any = { from, to };
        if (userId) params.userId = userId;
        if (shiftId) params.shiftId = shiftId;
        const r = await axios.get(ENDPOINTS.SHIFT.ROSTER(institutionId), { params });
        return r.data;
    },
    overrideCell: async (institutionId: string, instanceId: string, body: OverrideRequest): Promise<RosterCell> => {
        const r = await axios.post(ENDPOINTS.SHIFT.ROSTER_OVERRIDE(institutionId, instanceId), body);
        return r.data;
    },
    resetCell: async (institutionId: string, instanceId: string): Promise<void> => {
        await axios.post(ENDPOINTS.SHIFT.ROSTER_RESET(institutionId, instanceId));
    },
    bulkSwap: async (institutionId: string, body: BulkSwapRequest): Promise<RosterCell[]> => {
        const r = await axios.post(ENDPOINTS.SHIFT.ROSTER_BULK_SWAP(institutionId), body);
        return r.data;
    },
    regenerate: async (institutionId: string, from: string, to: string): Promise<{ generated: number }> => {
        const r = await axios.post(ENDPOINTS.SHIFT.ROSTER_REGENERATE(institutionId), null, { params: { from, to } });
        return r.data;
    },
};
